import { markRaw, defineAsyncComponent } from 'vue';
import type { DiscoveredRouteModule } from '@/router/generator/types';

// Local constants
const GroupsView = () => import('@/views/groups/BlogView.vue');
const GroupsBlogIndexView = () => import('@/views/groups/blog/IndexView.vue');
const GroupsBlogPostView = () => import('@/views/groups/blog/PostView.vue');
const GroupsBlogCreateView = () => import('@/views/groups/blog/CreateView.vue');
const GroupsBlogEditView = () => import('@/views/groups/blog/EditView.vue');
export const NAME_GROUPS = 'Groups';
export const NAME_GROUPS_BLOG_INDEX = 'GroupsBlogIndex';
export const NAME_GROUPS_BLOG_POST = 'GroupsBlogPost';
export const NAME_GROUPS_BLOG_CREATE = 'GroupsBlogCreate';
export const NAME_GROUPS_BLOG_EDIT = 'GroupsBlogEdit';
export const PATH_GROUPS = 'groups';

const GroupsHeaderComponent = defineAsyncComponent(() => import('@/components/app/groups/HeaderComponent.vue'));

const children = [
  { path: '', component: GroupsBlogIndexView, name: NAME_GROUPS_BLOG_INDEX, meta: { dynamicComponent: markRaw(GroupsHeaderComponent), dynamicComponentScale: 'scale-75', dataLoaders: ['project_document', 'features', 'project_groups', 'algolia', 'groups_store'] } },
  { path: 'post/:id', component: GroupsBlogPostView, name: NAME_GROUPS_BLOG_POST, meta: { dataLoaders: ['project_document', 'groups_store', 'blog_posts', 'blog_comments'] } },
  { path: 'create', component: GroupsBlogCreateView, name: NAME_GROUPS_BLOG_CREATE, meta: { dataLoaders: ['project_document', 'groups_store', 'blog_posts'] } },
  { path: 'edit/:id', component: GroupsBlogEditView, name: NAME_GROUPS_BLOG_EDIT, meta: { dataLoaders: ['project_document', 'groups_store', 'blog_posts', 'blog_comments'] } },
];

export const route: DiscoveredRouteModule = {
  id: 'app.groups',
  scope: 'app',
  moduleKey: 'groups',
  name: NAME_GROUPS,
  path: PATH_GROUPS,
  component: GroupsView,
  meta: {},
  requiresFeature: 'groups.blog',
  children,
};


